/**
 * Amplify Configuration
 *
 * Cognito configuration is loaded from environment variables.
 * These are set during deployment from CDK stack outputs.
 *
 * For local development, copy .env.example to .env and fill in values.
 */

import type { ResourcesConfig } from 'aws-amplify';

/**
 * Get Amplify configuration from environment variables.
 * Returns empty config if variables are missing (allows running without auth).
 */
export function getAmplifyConfig(): ResourcesConfig {
  const userPoolId = String(import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '');
  const userPoolClientId = String(import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '');

  if (!userPoolId || !userPoolClientId) {
    console.warn(
      'Missing Cognito configuration. Set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_USER_POOL_CLIENT_ID environment variables.'
    );
    // Return minimal config for development without auth
    return {
      Auth: {
        Cognito: {
          userPoolId: '',
          userPoolClientId: '',
        },
      },
    };
  }

  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true,
        },
      },
    },
  };
}

/**
 * Check if Cognito is configured.
 */
export function isCognitoConfigured(): boolean {
  const userPoolId = String(import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '');
  const userPoolClientId = String(import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '');
  return Boolean(userPoolId && userPoolClientId);
}
